import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from 'redux/hooks';

import { logout } from 'redux/users/actions';
import ChatMenu from 'components/ChatComponent/Menu/Menu';
import { BillingStatistic, Curator } from "components";
import { getUserCuratorInfo } from 'redux/users/actions';
import { setIsChatOpened } from "redux/chat/reducer";
import UserDropdown from 'components/UserDropdown/UserDropdown';
import { ReactComponent as CorpIcon } from "assets/icons/new/Corp/Icon.svg";

const MiniMenu = React.memo(({ sidebarOpen, hideMdElements, hideMiniLogo = false, setSidebarOpen }) => {
  const [isShowFullInfo, setIsShowFullInfo] = useState(false);

  const fullInfoBlock = useRef()
  const trigger = useRef()

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const openChatHandler = () => {
    dispatch(setIsChatOpened(true));
  }

  const { accessToken, userInfo, curator, currentUser } = useAppSelector(({ users }) => ({
    accessToken: users.currentUser.data.accessToken,
    userInfo: users.currentUser.info,
    curator: users.currentUser.curator,
    currentUser: users.currentUser.data,
  }))

  const logoutFromAccount = () => {
    dispatch(logout({id: currentUser.id}))
  }

  useEffect(() => {
    if (accessToken) {
      dispatch(getUserCuratorInfo());
    }
  }, [accessToken])

  const clickHandler = useCallback(({ target }) => {
    if (!fullInfoBlock.current) return;

    if (!isShowFullInfo || fullInfoBlock.current.contains(target) || trigger.current.contains(target)) return;

    setIsShowFullInfo(false);
  }, [fullInfoBlock.current, isShowFullInfo]);

  useEffect(() => {
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  }, [clickHandler]);

  return (
    <>
      {curator &&
        <div className='lg:px-[9px] py-[7px] maxh620:pl-0 maxh620:pr-[7px] sm:pr-[7px]'>
          <ChatMenu
            sidebarOpen={sidebarOpen}
            {...curator} 
            openChatHandler={openChatHandler}
            userShortId={userInfo.supportID && userInfo.supportID}
            hideMdElements={hideMdElements}
          />
        </div>
      }
      {!hideMdElements && <BillingStatistic
        plan={userInfo && userInfo.plan}
        balance={userInfo && userInfo.balance}
        sidebarOpen={sidebarOpen}
      />}
      {!hideMiniLogo && <div className="lg:px-[9px] lg:py-[7px] sm:p-[7px] maxh620:p-[7px] lg:h-[50px] maxh620:h-auto">
        <UserDropdown sidebarOpen={sidebarOpen} hideMdElements={hideMdElements} />
      </div>}
      {!hideMdElements && <div
        className={`h-[50px] lg:px-[9px] py-[7px] flex items-center gap-x-3 hover:text-theme-hover dark:hover:text-theme-hover`}
      >
        <div id="sidebarToggleButton" className="shrink-0" onClick={() => {
          setSidebarOpen(old => !old)
        }}>
          <CorpIcon width="20" height="20" fill="currentColor" />
        </div>
        <div
          className={`text-[9px] transition-all duration-300 ${sidebarOpen ? 'min-w-[150px] w-[150px] opacity-100' : 'w-0 opacity-0 hidden'}`}
        >
          <div className='flex gap-x-1 w-full truncate text-ellipsis'>
            <a href={"https://lk.market/legal/privacy"} rel="noreferrer" target="_blank">
              {t("Privacy policy")}
            </a>
            <a href={"https://lk.market/legal/terms"} rel="noreferrer" target="_blank">
              {t("Agreement")}
            </a>
            <Link to={"/welcome/service-agreement"}>{t("business_offer")}</Link>
          </div>
          <a href="https://lk.market" className="cursor-pointer block w-full truncate text-ellipsis">
            © 2020-{ new Date().getFullYear() } {t('company_name')}
          </a>
        </div>
      </div>}
      <div className='relative sm:p-[7px] maxh620:p-[7px]'>
        {(hideMdElements && !hideMiniLogo) &&
          <CorpIcon width="20" height="20" fill="currentColor" className="lg:hidden maxh620:block block" ref={trigger} onClick={() => setIsShowFullInfo(old => !old)} />
        }
        <div className={`absolute w-49 bg-theme-bg dark:bg-theme-bg rounded-bl-lg p-2 top-[calc(100%+6px)] -right-2.5 ${isShowFullInfo ? 'block' : 'hidden'}`} ref={fullInfoBlock}>
          {(isShowFullInfo && !hideMiniLogo) && <MiniMenu sidebarOpen={true} hideMiniLogo={true} />}
        </div>
      </div>
    </>
  );
});

export default MiniMenu;